// Browser-build stub for `jsdom` - wired up via `resolve.alias` in vite.config.mts.
//
// `jsdom` is Node-only. The frontend never uses it: it is reachable solely
// through @binale-tech/shared's `CII/htmlDecode` `else` branch, which runs only
// when `typeof window === "undefined"` - i.e. never in the browser (there the
// branch uses `window.DOMParser`). But that branch contains a *static*
// `require("jsdom")`, so rolldown pulls the whole package into the bundle graph,
// dragging in jsdom's nested `undici`, whose `require("node:stream/web")` the
// node polyfill can't resolve (`stream-browserify` has no `/web` subpath) - which
// breaks `vite build`.
//
// Aliasing `jsdom` to this empty stub keeps it out of the browser bundle. The
// alias is skipped in test mode so vitest's `environment: "jsdom"` still gets the
// real package.
export class JSDOM {}
